/* Kings Yard · ky-ui.js (site de teste) — aviso "15 km" junto ao WhatsApp:
   mostrado uma vez por sessão, esconde-se sozinho ~7 s depois de ficar visível (após a verificação de idade), continua a poder ser fechado no ×.
   Esconde por classe (o texto fica no DOM), sem mexer no model.js. */
(function () {
  var SEEN = 'ky_note_seen', tries = 0;
  function gated() { var d = document.documentElement; return d.classList.contains('ky-gated') || document.body && document.body.classList.contains('ky-gated'); }
  function hide(n) { n.classList.add('ky-hide'); n.setAttribute('aria-hidden', 'true'); }
  function run() {
    var n = document.getElementById('ky-wa-note');
    if (!n) { if (++tries < 40) setTimeout(run, 250); return; }
    try { if (sessionStorage.getItem(SEEN)) { hide(n); return; } } catch (e) {}
    (function wait() {
      if (!document.getElementById('ky-wa-note')) return;
      if (gated()) return setTimeout(wait, 400);
      try { sessionStorage.setItem(SEEN, '1'); } catch (e) {}
      setTimeout(function () { hide(n); }, 7000);
    })();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
